import { render, staticRenderFns } from "./page1.vue?vue&type=template&id=37b5fbc5&scoped=true&"
import script from "./page1.vue?vue&type=script&lang=js&"
export * from "./page1.vue?vue&type=script&lang=js&"
import style0 from "./page1.vue?vue&type=style&index=0&id=37b5fbc5&lang=less&scoped=true&"
import style1 from "./page1.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b5fbc5",
  null
  
)

export default component.exports